import {
  Dumbbell,
  Kanban,
  Martini,
  UtensilsCrossed
} from "lucide-react";

export const productPortfolio = [
  {
    id: "wbm",
    name: "WBM - Bar Management",
    shortName: "WBM",
    category: "Bar Management SaaS",
    url: "https://wbm.willovate.in/",
    status: "live",
    statusLabel: "Live Product",
    icon: Martini,
    description:
      "AI-powered bar management for counter sheets, stock movement, billing, purchases, staff shifts, and daily business control.",
    homeDescription:
      "Counter sheets, stock, billing, purchases, and AI reports for bar operations.",
    features: ["Counter Sheets", "Stock Control", "Billing", "AI Reports"],
    seoDescription:
      "AI-powered bar management software for counter sheets, stock movement, billing, purchases, staff shifts, and daily sales reports."
  },
  {
    id: "task",
    name: "Willovate Task",
    shortName: "Task",
    category: "Project Management",
    url: "https://task.willovate.in/",
    status: "live",
    statusLabel: "Live Product",
    icon: Kanban,
    description:
      "A Jira and Azure Boards style workspace to manage projects, boards, backlogs, tasks, sprints, milestones, and team delivery.",
    homeDescription:
      "Boards, backlogs, sprints, milestones, and team delivery in one project workspace.",
    features: ["Kanban Boards", "Backlogs", "Sprints", "Team Tracking"],
    seoDescription:
      "Project management software for boards, backlogs, tasks, sprints, milestones, team collaboration, and delivery tracking."
  },
  {
    id: "gym",
    name: "Willovate Gym",
    shortName: "Gym",
    category: "Gym Management",
    url: "https://gym.willovate.in/",
    status: "live",
    statusLabel: "Live Product",
    icon: Dumbbell,
    description:
      "Complete gym management with memberships, attendance, plans, renewals, trainer workflows, leads, WhatsApp marketing, and campaign follow-ups.",
    homeDescription:
      "Memberships, attendance, renewals, trainers, leads, and WhatsApp marketing.",
    features: ["Memberships", "Attendance", "Renewals", "WhatsApp Marketing"],
    seoDescription:
      "Gym management software for memberships, attendance, renewals, trainer workflows, leads, WhatsApp marketing, and campaign follow-ups."
  },
  {
    id: "resto",
    name: "WillovateResto",
    shortName: "Resto",
    category: "Restaurant Management",
    url: "https://resto.willovate.in/",
    status: "live",
    statusLabel: "Live Product",
    icon: UtensilsCrossed,
    description:
      "All-in-one AI-powered restaurant management for orders, inventory, menu operations, payments, WhatsApp automation, and analytics.",
    homeDescription:
      "Orders, inventory, menu, payments, WhatsApp automation, and analytics for restaurants.",
    features: ["Orders", "Inventory AI", "Payments", "Analytics"],
    seoDescription:
      "AI-powered restaurant management platform covering orders, inventory, menu operations, payments, WhatsApp automation, and analytics."
  }
];

export const productUrls = productPortfolio.map((product) => product.url);
